import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import * as reactTableModule from 'react-table';

const { useAsyncDebounce } = reactTableModule.default || reactTableModule;
import { Input, Label } from 'reactstrap';
import { v4 as uuid } from 'uuid';

import { messages } from '../../i18n/messages';

import styles from './SearchInput.module.scss';

const propTypes = {

	/**
	 * Placeholder text for search input.
	 */
	searchPlaceholder: PropTypes.string,

	/**
	 * The current global filter state for the table.
	 */
	globalFilter: PropTypes.string,

	/**
	 * Callback to set the global filter state.
	 */
	setGlobalFilter: PropTypes.func.isRequired,

};

/**
 * Search input for the Table component.
 *
 * @param {Object} props  The component props.
 *
 * @returns {Object}  The SearchInput component.
 */
const SearchInput = (props) => {

	const { searchPlaceholder, globalFilter, setGlobalFilter } = props;

	const intl = useIntl();

	const [value, setValue] = useState(globalFilter);

	const onChange = useAsyncDebounce((newValue) => {
		setGlobalFilter(newValue || undefined);
	}, 200);

	const defaultPlaceholderText = intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_SEARCH);
	const searchLabel = searchPlaceholder || defaultPlaceholderText;

	const inputID = `tc-table-search-input-${uuid()}`;

	return (
		<Fragment>
			<Label
				for={inputID}
				hidden>
				{searchLabel}
			</Label>
			<Input
				id={inputID}
				className={styles['tc-table-search-input']}
				value={value || ''}
				placeholder={searchLabel}
				onChange={(event) => {
					setValue(event.target.value);
					onChange(event.target.value);
				}} />
		</Fragment>
	);

};

SearchInput.propTypes = propTypes;

export default SearchInput;
